module.exports = __webpack_public_path__ + "img/pattern-bg.289b18ef.svg";